import React, { useEffect, useMemo } from 'react';
import { Container, CoverAppImageContainer, CoverAppLink, CoverImage, CoverImageText } from './styles';
import { AcervoAPI, VinculosAPI } from '../../http-requests';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SpinnerConstructor } from '../index';
import Axios from 'axios';
import { connect } from 'react-redux';
import { StyleHelper } from '../../helpers/StyleHelper';

const AppCover = (props) => {


    const
        {
        isbn,
        codAcervo,
        src,
        altSrc,
        title,
        textColor = '#ffffff',
        link = undefined,
        width = '168px',
        height = '237px' ,
        onClick,
        instituicaoRx
        } = props;

    const [imageSrc, setImageSrc] = React.useState(null);
    const [loading, setLoading] = React.useState(true);



    useEffect(() => {
        const cancelTokenSrc = Axios.CancelToken.source();
        const { token } = cancelTokenSrc;

        (async() => {
            if(!src){
                setImageSrc(null)
            }
            else if(src.trim().toLowerCase() === 'vínculo no banco' && codAcervo !== undefined){
                const response = await VinculosAPI.buscarImagensAcervo(
                    codAcervo,
                    1,
                    token,
                )

                const { data } = response;
                if(data && data?.length > 0) {
                    setImageSrc("data:image/jpg;base64, " + data[0]?.conteudo)
                }
            }else{
                const pattern = /^[SN]/
                setImageSrc(pattern.test(src.trim()) ? src.replace(pattern, '') : src)
            }

            setLoading(false)
        })()
        return () => {
            cancelTokenSrc.cancel()
        }

    }, [src]);


    const getTextColor = useMemo(() =>  StyleHelper.isRgb(textColor) ? `rgb(${textColor})` : textColor, [textColor] )

    if(!src && !altSrc){
        return '';
    }

    return (
        <Container
            title={title}
            width={loading ? '168px' : width}
            height={loading ? '237px' : height}>
            {
                loading ? (
                    <div className='d-flex flex-column justify-content-center align-items-center w-100 h-100'>
                        <FontAwesomeIcon  icon="image" className="preto50 mb-1" />
                        <SpinnerConstructor
                            grow
                            visible
                            className="preto50"
                            height={40}
                            width={40}
                        />
                    </div>
                ) : link ? (
                    <CoverAppLink to={link}>
                        <CoverImage
                            className='img-fluid'
                            src={imageSrc !== null ? imageSrc : altSrc} alt={title} />
                        {
                            imageSrc === null ? (
                                <CoverImageText $color={getTextColor}>{title}</CoverImageText>
                            ) : ''
                        }
                    </CoverAppLink>
                ) : (
                    <CoverAppImageContainer
                        onClick={() => {
                            if(onClick && typeof onClick === 'function'){
                                onClick()
                            }
                        }}
                    >
                        <CoverImage
                            className='img-fluid'
                            src={imageSrc !== null ? imageSrc : altSrc} alt={title} />
                        {
                            imageSrc === null ? (
                                <CoverImageText $color={getTextColor}>{title}</CoverImageText>
                            ) : ''
                        }
                    </CoverAppImageContainer>
                )
            }
        </Container>
    )
}


function mapStateToProps(state) {
    return {
        instituicaoRx: state.instituicao.data,
    };
}

export default connect(mapStateToProps)(AppCover);
